<crnt-form-control>
  <crnt-form-control-label slot="label">
    <label [for]="control.id">
      {{ control.options.label }}
      @if (showOptional) {
        <crnt-form-control-label-indicator>
          (optioneel)
        </crnt-form-control-label-indicator>
      }
    </label>
  </crnt-form-control-label>
  @if (control.options.helpText) {
    <crnt-form-control-help-text slot="help">
      {{ control.options.helpText }}
    </crnt-form-control-help-text>
  }
  @if (control.hasError()) {
    <rfa-errors slot="validation" [control]="control"></rfa-errors>
  }
  <crnt-text-input>
    <textarea
      [id]="control.id"
      [formControl]="control"
      [autocomplete]="autocompleteId"
      [wlTrackFieldfocus]="focusChangeTrackConfig()"
      [wlAutomationId]="control.options.dataAutomationId"
    ></textarea>
  </crnt-text-input>
  @if (control.options.maxLength) {
    @if (charactersLeft >= 0) {
      <span>{{ charactersLeftText }}</span>
    } @else {
      <span class="color-danger">{{ tooManyCharactersText }}</span>
    }
  }
</crnt-form-control>
